import { FC, ReactNode } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

/**
 * 各模块内的卡片（带标题和黑背景）
 * @description
 * @demo
 */
const Component:FC<{
  children: ReactNode,
  title: string,
  className?: string,
}> = ({ children, title, className }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={cs(styles.card, className)}>
    <div className={styles.title}>{title}</div>
    <div className={styles.content}>{children}</div>
  </div>);
};

export default Component;
